import './accueil.scss';
import '../../Inclusions/entetes/_entete.js';
import '../../Inclusions/pieds/_pied.js';
import '../../Inclusions/menus/_menu.js';
// JS spécifique à la page
import { initRecherchePlaceholder } from '../../../../src/_js/_recherche-placeholder.js';
initRecherchePlaceholder();